import React, { useState } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getPercentIncrease, formatPercentage } from '../../utils/helpers'

const KPI = ({ kpiId, name, previous, current, timeSpan, homePage, tabs }) => {
  const [entered, setEntered] = useState(false)

  const handleMouseEnter = () => {
    setEntered(true)
  }

  const handleMouseLeave = () => {
    setEntered(false)
  }

  const percentIncrease = getPercentIncrease(previous, current)

  if (homePage) {
    return (
      <Link
        to={`/kpi/${kpiId}`}
        style={{
          textDecoration: 'none'
        }}
      >
        <Card
          elevation={0}
          sx={{
            border: 'solid 3px #27417A',
            minHeight: '235px',
            maxHeight: '235px',
            width: { md: '220px', xs: '235px' },
            textAlign: 'center',
            backgroundColor: entered ? '#eff4fa' : '#ffffff',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'columm',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <CardContent>
            <Typography
              variant='h6'
              sx={{
                textDecoration: 'underline',
                color: '#27417A'
              }}
            >
              {name}
            </Typography>
            <Typography
              variant='h4'
              sx={{
                mt: 1,
                mb: 2,
                color: '#3A6DAA',
              }}
            >
              {current}
            </Typography>
            {
              timeSpan < 5 && (
                <>
                  <Typography
                    variant='h5'
                    sx={{
                      color: percentIncrease < 0 ? '#eb5757' : '#229653'
                    }}
                  >
                    {formatPercentage(percentIncrease)}
                  </Typography>
                  <Typography>from last {tabs[timeSpan].value}</Typography>
                </>
              )
            }
          </CardContent>
        </Card>
      </Link>
    )
  }

  return (
    <Card
      elevation={0}
      sx={{
        border: 'solid 3px #27417A',
        minHeight: '235px',
        maxHeight: '235px',
        width: { md: '220px', xs: '235px' },
        textAlign: 'center',
        backgroundColor: entered ? '#eff4fa' : '#ffffff',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'columm',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CardContent>
        <Typography
          variant='h6'
          sx={{
            textDecoration: 'underline',
            color: '#27417A'
          }}
        >
          {name}
        </Typography>
        <Typography
          variant='h4'
          sx={{
            mt: 1,
            mb: 2,
            color: '#3A6DAA',
          }}
        >
          {current}
        </Typography>
        {
          timeSpan < 5 && (
            <>
              <Typography
                variant='h5'
                sx={{
                  color: percentIncrease < 0 ? '#eb5757' : '#229653'
                }}
              >
                {formatPercentage(percentIncrease)}
              </Typography>
              <Typography>from last {tabs[timeSpan].value}</Typography>
            </>
          )
        }
      </CardContent>
    </Card>
  )
}

KPI.propTypes = {
  kpiId: PropTypes.number,
  name: PropTypes.string,
  previous: PropTypes.number,
  current: PropTypes.number,
  timeSpan: PropTypes.string,
  homePage: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  )
}

export default KPI